var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.required)?_c('span',{staticClass:"required"},[_vm._v("*")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('v-text-field',{attrs:{"rules":_vm.rules,"placeholder":_vm.placeholder,"required":_vm.required,"outlined":"","dense":""},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }